const getContextLocale = ({ contextLocale }: { contextLocale: string | null }): string | null => {
    return contextLocale;
};

export default { getContextLocale };
